import type { FormAdditionalSettingsComposed, ServiceForm } from '@/services/domain/services/forms/types'
import type { PhoneType } from '@/services/types'

export const clickToTextPositionVariant = ['right', 'left', 'center'] as const
export type ClickToTextPosition = (typeof clickToTextPositionVariant)[number]

export type ClickToTextAppearanceTexts = {
  header: string
  phoneNumberVisible: boolean
  phoneNumber: string
  phoneType: PhoneType
  description: string
  submitText: string
  completedTitle: string
  completedDescription: string
}

export type ClickToTextAppearanceTextsComposed = {
  title: string
  hidePhoneMinimized: boolean
  phone: string
  phoneType: PhoneType
  description: string
  labelButton: string
  successMessage: string
  additionalText: string
}

export type ClickToTextAppearanceFields = {
  nameLabel: string
  nameVisible: boolean
  phoneNumberLabel: string
  messageLabel: string
}

export type ClickToTextAppearanceFieldsComposed = {
  labelName: string
  hideName: boolean
  labelPhone: string
  labelMessage: string
}

export type ClickToTextAppearanceColors = {
  headerColor: string
  phoneNumberColor: string
  submitColor: string
}

export type ClickToTextAppearanceColorsComposed = {
  titleColour: string
  descriptionColour: string
  buttonColour: string
}

export type ClickToTextAppearancePosition = {
  position: ClickToTextPosition
}

export type ClickToTextAppearancePositionComposed = {
  position: number
}

export type ClickToTextAppearance = ClickToTextAppearanceTexts &
  ClickToTextAppearanceFields &
  ClickToTextAppearanceColors &
  ClickToTextAppearancePosition

export type ClickToTextForm = ServiceForm & ClickToTextAppearance

export type ClickToTextFormComposed = ClickToTextAppearanceTextsComposed &
  ClickToTextAppearanceFieldsComposed &
  ClickToTextAppearanceColorsComposed &
  ClickToTextAppearancePositionComposed &
  FormAdditionalSettingsComposed
